// TEMPORARY MIGRATION CODE — remove with the rest of lib/migration/. See ./AGENTS.md.
//
// Maps the legacy ClientConsole reset hash (`#/reset`) onto web's public path
// route `/login/reset`, preserving any query params. No org prefix: the reset
// flow is unauthenticated. Pure, so it unit-tests in node. Returns `null` for
// any hash that isn't the reset link.
export const mapLegacyResetHash = (hash: string): string | null => {
  if (!hash.startsWith("#/")) return null
  const stripped = hash.slice(1)
  const queryStart = stripped.indexOf("?")
  const path = queryStart === -1 ? stripped : stripped.slice(0, queryStart)
  // Exact match — don't catch "/reset-password" or other "/reset…" segments.
  if (path !== "/reset") return null
  const query = queryStart === -1 ? "" : stripped.slice(queryStart)
  return `/login/reset${query}`
}
